import service from "./service.js";
export const getlist = () => {
  return service.get(`/v1/role`);
};

export const access = (rule, roleId, featureId) => {
  return service.post(`/v1/role/access`, { rule, roleId, featureId });
};

export const create = role => {
  return service.post(`/v1/role`, { role });
};

export const update = (id, role) => {
  return service.post(`/v1/role/${id}/update`, { role });
};

export const updateFeatureGroup = (id, featureGroup) => {
  return service.post(`/v1/featureGroup/${id}/update`, { featureGroup });
};

export const updateFeature = (id, feature) => {
  return service.post(`/v1/feature/${id}/update`, { feature });
};
